import { BreadcrumbItem } from '@ixicare/ui';
import { OrganizationNodeProps } from '@ixicare/resources';
import { t } from '~/i18n';
import { organizationAnchor } from '~/modules/sites/hooks/useOrganizations';
import routes from './routes';

/**
 * Trail roots, one per nav destination. A page registers the crumbs below its own root: pages
 * under `siteWrapper` get theirs from the wrapper, every other page starts its trail from one of
 * these. The root has to be linkable for the layout to derive a back link from the trail.
 *
 * Functions, not constants: `t` needs i18n loaded, which happens after module evaluation.
 */
const crumbs = {
  alerts: (): BreadcrumbItem => ({ label: t('menu.dashboard.alerts'), href: routes.alerts }),
  residents: (): BreadcrumbItem => ({ label: t('menu.dashboard.residents'), href: routes.residents }),
  healthcareProviders: (): BreadcrumbItem => ({
    label: t('menu.dashboard.healthcareProviders'),
    href: routes.healthcareProviders,
  }),
  hcpGroups: (): BreadcrumbItem => ({ label: t('menu.dashboard.hcpGroups'), href: routes.hcpGroups }),
  sites: (): BreadcrumbItem => ({ label: t('menu.dashboard.settingsSites'), href: routes.sites }),
  organization: (org: OrganizationNodeProps): BreadcrumbItem => ({
    label: org.name,
    href: `${routes.sites}#${organizationAnchor(org.id)}`,
  }),
  deviceOverview: (): BreadcrumbItem => ({ label: t('menu.dashboard.deviceOverview'), href: routes.deviceOverview }),
  deviceHealth: (): BreadcrumbItem => ({ label: t('menu.dashboard.deviceHealth'), href: routes.deviceHealth }),
};

export default crumbs;
